import styles from './styles.module.scss';

import React from 'react';
import { useTranslation } from 'react-i18next';

import { BUSINESS_INFO_TEST_ID } from 'routes/Menu/BusinessInfo/const';
import { useMerchant } from 'hooks/context/merchant';
import { ServiceHours } from 'routes/Menu/BusinessInfo/ServiceHours';
import { formatPhoneNumber } from 'util/Formatting';
import { Shimmer } from 'routes/Menu/BusinessInfo/Shimmer';
import { useWindowSize } from 'hooks/breakpoints';
import { LoginButton } from 'components/LoginButton';
import cx from 'clsx';
import { useCustomer } from 'hooks/context/customer/customer';
import { useMerchantState } from 'hooks/context/MerchantState';
import { usePerks } from 'hooks/context/Perks';
import { MerchantLogo } from 'components/MerchantLogo';
import { PerkButton } from 'components/PerkButton';

type BusinessInfoProps = {
  hideServiceHours?: boolean;
};

export const BusinessInfo: React.FC<BusinessInfoProps> = ({ hideServiceHours }) => {
  const { t } = useTranslation();
  const { merchant, service, isLoading } = useMerchant();
  const { showCustomerAuthState } = useMerchantState();
  const { isLoggedIn } = useCustomer();
  const { isDesktop } = useWindowSize();
  const { availablePerks, atLeastOnePerk, isLoading: isPerksLoading } = usePerks();

  if (isLoading) return <Shimmer />;

  if (!merchant) return <div className={styles.info} />;

  const { name, address, timezone, phone } = merchant;

  return (
    <div className={styles.info}>
      <div className={styles.merchantInfo}>
        <MerchantLogo />
        <div data-testid={BUSINESS_INFO_TEST_ID.root}>
          <h1 data-testid={BUSINESS_INFO_TEST_ID.name} className={styles.merchantName}>{name}</h1>
          <p data-testid={BUSINESS_INFO_TEST_ID.address}>
            {t('address.oneLine', address)}
          </p>
          {phone && <p data-testid={BUSINESS_INFO_TEST_ID.phoneNumber} className={styles.phone}>
            {formatPhoneNumber(phone)}
          </p>}
        </div>
      </div>
      <div className={cx(styles.rightContent)}>
        {isDesktop && <div className={cx(styles.desktopPerkContainer)}>
          {isLoggedIn && !isPerksLoading && atLeastOnePerk && <PerkButton numAvailablePerks={availablePerks.length} />}
          {showCustomerAuthState && <LoginButton className={cx(styles.desktop, { [styles.loggedIn]: isLoggedIn })} />}
        </div>}
        {!hideServiceHours && timezone && service && <ServiceHours timezone={timezone} service={service} className={styles.hours} />}
        {isLoggedIn && !isPerksLoading && atLeastOnePerk && !isDesktop && <PerkButton numAvailablePerks={availablePerks.length} />}
      </div>
    </div>
  );
};
